// src/services/api.js
import axios from "axios";
import Swal from "sweetalert2";
import { getServerUrls } from "./url";

const SERVERS = [
  // "http://localhost:8000/api",
  // "https://school.trackingacademy.in/backend/public/api",
  // "https://bonnenehru.trackingacademy.in/backend/public/api",
  // "https://kidspark.trackingacademy.in/backend/public/api",
  "https://bestschool.trackingacademy.in/backend/public/api",


];

// `activeBaseUrl` persists across app launches, so a session started before the
// server list changed would keep calling the old backend — and its device token
// would stay in that backend's app_device_tokens, where the new backend can
// never find it to send a push. Drop it and force a re-login instead.
let storedBaseUrl = localStorage.getItem("activeBaseUrl");
if (storedBaseUrl && !SERVERS.includes(storedBaseUrl)) {
  localStorage.clear(); // same as logout — the old session's token is not valid here
  storedBaseUrl = null;
}

const api = axios.create({
  baseURL: storedBaseUrl || "", // Will be set after login
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 10000,
});

export async function logindata(data) {
  let reachable = false;
  let lastResult = null;

  for (const server of SERVERS) {
    try {
      const response = await axios.post(`${server}/login`, data);
      const result = response.data;
      reachable = true;
      lastResult = result;

      if (result.status === true) {
        localStorage.setItem("activeBaseUrl", server);
        api.defaults.baseURL = server;
        const { exportUrl, reportUrl } = getServerUrls();
        localStorage.setItem("exportUrl", exportUrl);
        localStorage.setItem("reportUrl", reportUrl);

        return result; // successful login
      }
    } catch (error) {
      // Server responded with a rejection (e.g. 401/422) — keep its message
      if (error.response && error.response.data) {
        reachable = true;
        lastResult = error.response.data;
      } else {
        console.log(`Login failed on ${server}`);
      }
    }
  }

  // A server was reachable but rejected the login (wrong username/password)
  if (reachable) {
    return {
      status: false,
      message: (lastResult && lastResult.message) || "Invalid username or password",
    };
  }

  // No server could be reached at all
  Swal.fire("Login Failed", "All servers are unreachable", "error");
  return { status: false, message: "All servers are unreachable" };
}

export default api;
